import React from 'react';
import Hero from '../components/Hero';
import WhyWorkWithMe from '../components/WhyWorkWithMe';
import LiveDemoCard from '../components/LiveDemoCard';
import Problem from '../components/Problem';
import Deliverables from '../components/Deliverables';
import Process from '../components/Process';
import ValuePillars from '../components/ValuePillars';
import FinalCTA from '../components/FinalCTA';
import useSEO from '../hooks/useSEO';

const Home = () => {
  useSEO(
    'Customer Acquisition Systems for Local Businesses | Barcelona | Mathias Deppe',
    'I help local businesses in Barcelona turn attention into leads and customers through sales-focused messaging, premium content and simple automation.'
  );

  return (
    <>
      <Hero />
      <WhyWorkWithMe />
      <LiveDemoCard />
      <Problem />
      <Deliverables />
      <Process />
      <ValuePillars />
      <FinalCTA />
    </>
  );
};

export default Home;